import React from "react";
import { TextInput, InputWrapper } from "@mantine/core";
import { GenericFieldProps } from "utils/forms";
import NumberFormat from "react-number-format";

const CustomNumberInput: React.FC<any> = (inputProps) => {
    return <TextInput  {...inputProps} type="tel" />;
};

const PhoneField: React.FC<GenericFieldProps> = ({ id, name, label, onChange, onBlur, value, error, required, description, classNames }) => {
    return (
        <InputWrapper
            id={id}
            label={label}
            onBlur={onBlur}
            error={error}
            required={required}
            description={description}
            classNames={classNames}
        >
            <NumberFormat
                id={id}
                name={name}
                value={value}
                type="tel"
                onValueChange={(values)=>onChange(values.formattedValue)}
                format="(###) ###-####"
                mask="_"
                allowEmptyFormatting={false}
                customInput={CustomNumberInput}
                classNames={classNames}
                error={error}
            />
        </InputWrapper>
    )

}

export default PhoneField;